import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export const LoadingState = ({ message }) => {
  return (
    <MDBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" py={8}>
      <CircularProgress size={60} sx={{ mb: 3 }} />
      <MDTypography variant="h6" color="text.secondary" textAlign="center">
        {message}
      </MDTypography>
    </MDBox>
  );
};

LoadingState.propTypes = {
  message: PropTypes.string.isRequired,
}; 